import { render, staticRenderFns } from "./stock-history.vue?vue&type=template&id=4d27c62d"
import script from "./stock-history.vue?vue&type=script&lang=js"
export * from "./stock-history.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports